import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Button } from 'react-bootstrap';
import AuthNavbar from '../navbars/AuthNavbar';
import axios from 'axios';

function ActivateAccountPage() {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            setMessage('Chýba aktivačný token.');
            return;
        }

        const activateAccount = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/activate`, {
                    params: { token }
                });
                setStatus('success');
                setMessage(response.data.msg || 'Účet bol úspešne aktivovaný.');
            } catch (err) {
                setStatus('error');
                setMessage(err.response?.data?.detail || 'Chyba pri aktivácii účtu.');
            }
        };

        activateAccount();
    }, [searchParams]);

    return (
        <>
            <AuthNavbar />
            <Container className="mt-4 text-center">
                {status === 'loading' && <Spinner animation="border" />}
                {status === 'success' && (
                    <>
                        <Alert variant="success">{message}</Alert>
                        <Button onClick={() => navigate('/login')}>Prejsť na prihlásenie</Button>
                    </>
                )}
                {status === 'error' && <Alert variant="danger">{message}</Alert>}
            </Container>
        </>
    );
}

export default ActivateAccountPage;
